module.exports = __webpack_public_path__ + "LatoLatin-MediumItalic.075f27df741c07fc07c0.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-MediumItalic.eot
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-MediumItalic.eot
// module chunks = styles